export default "__VITE_ASSET__BrRhz$Bd__"